import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class CountryColumn extends Column {
    title = 'company.offices.countryColumn';
    property = 'country';
    sortable = true;
    type: CellDisplay = CellDisplay.string;
}
